import { Thermostat } from './thermostat.model';
export class NATherm1 extends Thermostat {

}
